import React, { createContext, type ReactNode, useContext } from 'react'
import { type PersonType } from '../types/general'

/** A merge column's heading text and the text of its info button */
export type ColumnHeading = {
  heading: string
  infoText: string
}

export type ColumnHeadings = Record<PersonType, ColumnHeading>

const ColumnHeadingsContext = createContext<ColumnHeadings | undefined>(undefined)

/**
 * The column headings in place of the merge preview's ("Duplicate Person", "Main Person", "Final Result"), for every
 * PersonColumnHeading below: the page's and those in its dialogs. A completed merge names its columns for what they
 * show, the persons before and after the merge.
 */
export default function ColumnHeadingsProvider({
  children,
  headings,
}: {
  children: ReactNode
  headings: ColumnHeadings | undefined
}): JSX.Element {
  return <ColumnHeadingsContext.Provider value={headings}>{children}</ColumnHeadingsContext.Provider>
}

/** The column's heading from a ColumnHeadingsProvider, or undefined for the merge preview's */
export const useColumnHeading = (personType: PersonType): ColumnHeading | undefined =>
  useContext(ColumnHeadingsContext)?.[personType]
